import React from 'react';
import customEditor from '../../utils/customEditor';
import { Button } from '@mui/material';

const MarkButton = ({ editor, children, format }) => {
	const isActive = customEditor.isMarkActive(editor, format);
	return (
		<Button
			color={isActive ? 'info' : 'primary'}
			onMouseDown={(e) => {
				e.preventDefault();
				customEditor.toggleMark(editor, format);
			}}
		>
			{children}
		</Button>
	);
};

export default MarkButton;
